import { useEffect, useMemo, useState } from 'react';
// import _0057_i from '@/assets/images/0057_i.svg';
import {
  downFile,
  isAndroid,
  isIOS,
  isSupportPWA,
  PWA_Installed
} from '@/utils/index';
import { useLocation } from 'react-router-dom';
import { Mask, Popup, Space, Toast } from 'antd-mobile';
import { CheckCircleOutline } from 'antd-mobile-icons';
import { useCommonVisible } from '@/hooks';
import ApplePopup from './ApplePopup';
import { UAParser } from 'ua-parser-js';
import { reportParams } from '@/utils/crypto';
import Cookies from 'js-cookie';
// export const PWA_Installed = '__yz_pwa_installed__';

let timerId: any = 0;
const RETRY_COUNT_MAX = 5;
const installTime = 15000;
const installInterval = Math.ceil(installTime / 99);

const step = 1;
const detectTime = 15000;
const detectInterval = Math.ceil(detectTime / 100);

// const { logoUrl, siteName } = (window as any).appConfig || {};

// 首页下载框，下载逻辑同安装引导配置
const DownloadPopup = ({
  downloadConfig,
  installBanner,
  configInfo,
  detectPercent,
  deferredPrompt,
  setDetectPercent,
  setDeferredPrompt
}) => {
  const [visible, setVisible] = useState(true);
  const [isIosPopup, setIsIosPopup] = useState(false);
  const { search } = useLocation();
  // const { getToken } = getUserInfo();
  // const [searchParams] = useSearchParams();
  // const queryParams = search;

  const { logoUrl, siteName } = (window as any).appConfig || {};
  const urlParams = new URLSearchParams(search.split('?')[1]);
  const textConfig = useMemo(
    () => downloadConfig.find(item => item.type === 'Text'),
    [downloadConfig]
  );
  const [precent, setPrecent] = useState(0);

  const detectDialog = useCommonVisible();

  const handleInstallApp = () => {
    const { apple, appleLink, android, apkLink } = configInfo;
    if (isIOS) {
      switch (apple) {
        case 0: // 添加到桌面
          setIsIosPopup(true);
          break;
        case 1: // 苹果AppStore
          window.open(appleLink);
          break;

        default:
          break;
      }
    } else {
      const fileName = apkLink ? apkLink?.split('/').pop() : '';
      switch (android) {
        case 0: // pwa(快捷安装)
          handleInstall();
          break;
        case 1: // apk(需要自己封装)
          apkLink
            ? downFile(apkLink, fileName)
            : Toast.show('Pacote de download não configurado');
          // @ts-ignore
          if (window.trackFn && window.trackName) {
            console.log('判断是否有值CustomizeProduct');
            // @ts-ignore
            window.trackFn(window.trackName['CustomizeProduct'], {
              ...reportParams()
            });
          }
          break;
        case 2: // pwa(优先)+apk
          if (isSupportPWA()) {
            handleInstall();
          } else {
            apkLink
              ? downFile(apkLink, fileName)
              : Toast.show('Pacote de download não configurado');
            // @ts-ignore
            if (window.trackFn && window.trackName) {
              console.log('判断是否有值CustomizeProduct');
              // @ts-ignore
              window.trackFn(window.trackName['CustomizeProduct'], {
                ...reportParams()
              });
            }
          }
          break;

        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (detectDialog.visible) {
      timerId = setInterval(() => {
        setDetectPercent(precent => {
          const _precent = Math.floor(precent + step);
          if (_precent >= 100) {
            clearInterval(timerId);
            return 100;
          }
          return _precent;
        });
      }, detectInterval);
    }
  }, [detectDialog.visible]);

  let retryCount = 0;

  const timerFn = () => {
    timerId = setInterval(() => {
      setPrecent(precent => {
        const _precent = Math.floor(precent + step);
        if (_precent >= 99) {
          clearInterval(timerId);
          return 99;
        }
        return _precent;
      });
    }, installInterval);
  };

  const install = () => {
    try {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          //   setInstalling(true);
          timerFn();
          setTimeout(() => {
            clearInterval(timerId);
            setPrecent(100);
            // setInstalling(false);
            localStorage.setItem(PWA_Installed, 'true');
            localStorage.setItem('homeParams', urlParams.toString());
            Cookies.set('homeParams', urlParams.toString());
            installBanner.close();
          }, installTime);
        } else {
          console.log('---- 取消安装 ----');
          Toast.show('Você cancelou a instalação!');
        }
        // deferredPrompt = null
        setDeferredPrompt(null);
      });
    } catch (error) {
      if (retryCount < RETRY_COUNT_MAX) {
        setTimeout(() => {
          retryCount++;
          console.log('---- 安装失败 - 重试 ----', retryCount);
          install();
        }, 100);
      } else {
        console.log('---- 安装失败 ----', error);
        Toast.show('A instalação falhou!');
      }
    }
  };

  const handleInstall = async () => {
    console.log('进入了handleInstall');

    if (!(window as any).isChrome() && (window as any).isAndroid()) {
      const parser = new UAParser(navigator.userAgent);
      const browserName = parser.getBrowser().name;
      console.log(browserName);
      if (/FBAV|FBAN|FBIOS|FBAN|FB|FACEBOOK/i.test(browserName!)) {
        (window as any).launchChrome();
        return;
      }
    }

    if (!isSupportPWA()) {
      Toast.show('Seu navegador não suporta pwa');
      // const android_url = import.meta.env.VITE_ANDROID_URL;
      // if (android_url) {
      //   const fileName = android_url.split('/').pop();
      //   downFile(android_url, fileName);
      // } else {
      //   Toast.show('Você não configurou o endereço de download do aplicativo');
      // }
      return;
    }

    if (deferredPrompt) {
      console.log('开始安装');
      install();
      // @ts-ignore
      if (window.trackFn && window.trackName) {
        console.log('判断是否有值CustomizeProduct-安装pwa');
        // @ts-ignore
        window.trackFn(window.trackName['CustomizeProduct'], {
          ...reportParams()
        });
      }
    } else {
      // 如果不具备pwa的安装环境  则弹出加载动画 给出一个较长时间的动画  确定在此动画之后 浏览器具备安装pwa环境
      console.log('环境未准备好');
      detectDialog.open();
    }
  };
  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        setVisible(false);
      }}
      className="w-full flex align-center justify-center m-auto"
      bodyClassName="!w-[393px] !left-auto"
      bodyStyle={{
        borderTopLeftRadius: '24px',
        borderTopRightRadius: '24px',
        minHeight: '20vh',
        padding: '24px'
      }}
    >
      <div>
        <div className="flex items-center justify-start ">
          <img src={logoUrl} alt="" className="w-[60px] h-[60px] mr-6 " />
          <div>{textConfig?.content}</div>
        </div>
        <div className="flex items-center justify-end mt-4">
          <span
            onClick={() => setVisible(false)}
            className="w-[87px] h-8 text-black/45 bg-black/5 text-center flex items-center justify-center rounded-lg mr-4"
          >
            Cancelar
          </span>
          <span
            onClick={configInfo ? handleInstallApp : handleInstall}
            className="w-[87px] h-8 text-white bg-[#0784fe] text-center flex items-center justify-center rounded-lg"
          >
            Instalar
          </span>
        </div>
      </div>
      <ApplePopup isOpen={isIosPopup} closeModal={setIsIosPopup} />
      <Mask visible={detectDialog.visible}>
        <div className="p-[20px] bg-[#2F1780]/90 rounded-[10px] absolute left-[20px] right-[20px] text-center top-[-300%] bottom-0 m-auto h-[160px] flex items-center flex-col justify-evenly border-[2px] border-[#FFDF12]">
          <div className="font-semibold text-[18px] w-full">
            {detectPercent === 100 ? (
              <Space align="center">
                <CheckCircleOutline fontSize={20} color="#0BCF33" />
                <span className="text-[#FFFFFF] text-[14px]">
                  Detecção bem-sucedida
                </span>
              </Space>
            ) : (
              // '正在检测安装环境...'
              <span className="text-[#FFFFFF] text-[14px]">
                Detecção do ambiente de instalação...
              </span>
            )}
          </div>

          {detectPercent === 100 ? (
            <div
              onClick={() => {
                detectDialog.close();
                setTimeout(() => {
                  // 延后判断 确保触发beforeinstallprompt事件
                  console.log('deferredPrompt22', deferredPrompt);
                  console.log('configInfo22', configInfo);
                  if (deferredPrompt) {
                    if (configInfo) {
                      handleInstallApp();
                    } else {
                      handleInstall();
                    }
                  } else {
                    if (configInfo.apkLink) {
                      const fileName = configInfo.apkLink.split('/').pop();
                      downFile(configInfo.apkLink, fileName);
                    } else {
                      Toast.show(
                        'Você não configurou o endereço de download do aplicativo'
                      );
                    }
                  }
                }, 300);
              }}
              className={`text-center w-full h-[40px] text-[#2F1780] leading-[40px] rounded-[5px] bg-[#FFDF12]`}
            >
              Install Now
            </div>
          ) : (
            <div className="w-[60px] h-[60px] text-[#FFFFFF] detectDialog relative mt-[20px] mb-[20px] leading-[60px] m-auto">
              {detectPercent}%
            </div>
          )}
        </div>
      </Mask>

      <Mask visible={precent > 0 && precent < 100}>
        <div className="p-[20px] bg-[#2F1780]/90 rounded-[10px] absolute left-[20px] right-[20px] text-center top-[-300%] bottom-0 m-auto h-[160px] flex items-center flex-col justify-evenly border-[2px] border-[#FFDF12]">
          <div className="font-semibold w-full  text-[#FFFFFF] text-[14px]">
            Em instalação
          </div>

          <div className="w-[60px] h-[60px] text-[#FFFFFF] detectDialog relative mt-[20px] mb-[20px] leading-[60px] m-auto">
            {precent}%
          </div>
        </div>
      </Mask>
    </Popup>
  );
};

export default DownloadPopup;
